import type { ReactNode } from 'react';
import {
    ToggleButton,
    ToggleButtonComponentSpacing,
    ToggleButtonItem,
    ToggleButtonLabelSize,
    ToggleButtonLayoutStyle,
} from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { useEffect, useState } from 'react';

interface YesNoToggleButtonProps {
    id: string;
    value: boolean | undefined;
    required?: boolean;
    requiredMessage?: string;
    onItemClick: (e: ButtonGroupTypes.ItemClickEvent) => void;
    width?: string;
    height?: string;
    label?: any;
    labelSize?: ToggleButtonLabelSize;
    disabled?: boolean;
    showInfoIcon?: boolean;
    infoText?: ReactNode;
    /** Label above the buttons (Vertical, default) or beside them (Horizontal). */
    layoutStyle?: ToggleButtonLayoutStyle;
    /** Width of the label column when layoutStyle is Horizontal. Defaults to 120px. */
    labelWidth?: string;
    /** Vertical margin around the whole toggle. Omit for no margin (the original behaviour). */
    componentSpacing?: ToggleButtonComponentSpacing;
}

export const YesNoToggleButton: React.FC<YesNoToggleButtonProps> = ({
    id,
    value,
    required = false,
    requiredMessage,
    onItemClick,
    width = '230px',
    height = '40px',
    label,
    labelSize = ToggleButtonLabelSize.None,
    disabled = false,
    showInfoIcon = false,
    infoText,
    layoutStyle,
    labelWidth,
    componentSpacing,
}) => {
    const [toggleButtonState, set_toggleButtonState] = useState<string[]>([]);
    const toggleButtonItemsYesNo: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
            disabled: disabled,
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
            disabled: disabled,
        },
    ];

    useEffect(() => {
        let returnedValue = undefined;
        if (value != undefined && value != null) {
            if (value == true) {
                returnedValue = ['Yes'];
            } else {
                returnedValue = ['No'];
            }
        } else {
            returnedValue = [];
        }
        set_toggleButtonState(returnedValue);
    }, [value]);

    return (
        <ToggleButton
            id={id}
            items={toggleButtonItemsYesNo}
            selectedItems={toggleButtonState}
            selectionMode={value === undefined || value === null ? 'none' : 'single'}
            stylingMode='outlined'
            onItemClick={onItemClick}
            width={width}
            height={height}
            required={required}
            requiredMessage={requiredMessage}
            label={label}
            labelSize={labelSize}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            layoutStyle={layoutStyle}
            labelWidth={labelWidth}
            componentSpacing={componentSpacing}
        />
    );
};
